import { render } from "./IconFacebook.vue?vue&type=template&id=0189205d"
const script = {}
script.render = render

export default script